import { useState } from "react"
import styles from "../css/Anagrams.module.css"


import WordList from "../data/Words.json"
import ScrambleList from "../data/ScrambleWords.json"
import CountDownTimer from "../components/countdownTimer.jsx"

export default function Anagrams() {

    const [LetterCount, setLetterCount] = useState(6)
    const [letters, setLetters] = useState(Array(LetterCount).fill(null));

    const [guessedWords, setGuessedWords] = useState([])
    const [scrambledArray, setScrambledArray] = useState(Array(26).fill(0))

    const [ValidWords, setValidWords] = useState([])
    const [LegalWords, setLegalWords] = useState([])
    const [scrambleText, setScrambleText] = useState("");

    const [AvailableLetters, setAvailableLetters] = useState(Array(LetterCount).fill(1));
    const [wordCounts, setWordCounts] = useState(Array(10).fill(0))
    const [gameId, setGameId] = useState(0)


    const pointTotals = {
        3: 100,
        4: 400,
        5: 1200,
        6: 2200,
        7: 3000,
        8: 5000,
        9: 10000
    }
    function canMakeWord(word, scrambledArray) {
    
    
            let wordArr = genScrambledArray(word);
    
            for (let i = 0; i < 26; i++) {
                if (wordArr[i] <= scrambledArray[i]) {
                    continue
                }
                else {
                    return false;
                }
            }
    
            return true
    
    
        }

    function shuffleLetters(){
        const array = [...letters];
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i+1));

            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        setLetters(array);
    }
    function getAllLegalWords(length, validWords, scrambledArray){

    
    const legalWords = []
    for (const word of validWords) {
        if (canMakeWord(word, scrambledArray)) {
            legalWords.push(word);
        }
        
    }

    return legalWords

}

    function StartGame(forcedScramble) {

        console.log(`Forced Scramble: ${forcedScramble}`)
        setGameId(prev => prev + 1);
        const word =  generateWord(LetterCount);

        let scrambledWord;
        if (typeof forcedScramble === "string") {
            scrambledWord = forcedScramble.split("");
        } else {
            scrambledWord = scrambleWord(word);
        }


        setEnded(false)
        setLetters(scrambledWord)
        setStarted(true)
        setGuessedWords([])
        setPoints(0)
        setAvailableLetters(Array(LetterCount).fill(1));
       
        setWordCounts(Array(10).fill(0));

        const scrambledArray = genScrambledArray(scrambledWord)
        setScrambledArray(scrambledArray);

        const validWords = []
        const boxArray = []
        boxArray.push({length: 1});
        boxArray.push({length: 2});
        for (let i = 3; i <= LetterCount; i++) {
            validWords.push(...WordList[`${i}`])
            let sum = 0;
            boxArray.push({
                length: i
            });

            
        }
        
        

        
        
        setValidWords(validWords)
        const legalWords = getAllLegalWords(LetterCount, validWords, scrambledArray);
        const wordCountArray = Array(10).fill(0);
        
        for (const word of legalWords) {
            wordCountArray[word.length]++;
        }
        
        setWordCounts(wordCountArray);
        setLegalWords(legalWords);

        

    }

    function genScrambledArray(word) {
        let arr = Array(26).fill(0)

        for (const letter of word) {
            const l_index = letter.toLowerCase().charCodeAt(0) - 97
            arr[l_index] += 1;
        }
        return arr
    }
    const [guess, setGuess] = useState("");
    const [LastGuess, setLastGuess] = useState("");

    
    const [submitted, setSubmitted] = useState(false)

    const [guessText, setGuessText] = useState("")
    
    const [started, setStarted] = useState(false)

    const [points, setPoints] = useState(0);

    const [ended, setEnded] = useState(false)

    const [boxes, setBoxes] = useState(Array(LetterCount).fill(null))
    const [forcedScramble, setForcedScramble] = useState("");


    function setScrambleSubmit(e){
        e.preventDefault()
        StartGame(forcedScramble);
        setForcedScramble("")

    }

    function handleChange(e) {
        const newGuess = e.target.value.toUpperCase();
    
        setGuess(newGuess);
    
        const newAvail = Array(LetterCount).fill(1);
    
        for (const typedLetter of newGuess) {
            for (let i = 0; i < LetterCount; i++) {
                if (
                    newAvail[i] === 1 &&
                    letters[i]?.toUpperCase() === typedLetter
                ) {
                    newAvail[i] = 0;
                    break;
                }
            }
        }
    
        setAvailableLetters(newAvail);
}

    function handleSubmit(e) {
        e.preventDefault();

        if (!started || guess.length < 3 || guess.length > LetterCount || guess == '') {
            return
        }
        setSubmitted(true)
        setAvailableLetters(Array(LetterCount).fill(1));
        if (checkWord(guess)) {
            if (guessedWords.includes(guess)) {
                setGuessText(`You already have guessed ${guess}!`)
                setGuess("")
                return
            }



            const guessArr = genScrambledArray(guess);

            for (let i = 0; i < 26; i++) {

                if (guessArr[i] <= scrambledArray[i]) {
                    continue;
                }
                else {
                    setGuessText(`${guess} uses invalid letters! Please try again!`);
                    setGuess("")
                    return
                }
            }





            let pointsGained = pointTotals[guess.length]
            setGuessText(`${guess}: +${pointsGained} Points!`)
            setPoints((points + pointsGained))
            setGuessedWords([...guessedWords, guess])
            if([...guessedWords, guess].length >= LegalWords.length){
                setGuessText(`Successfully guessed all words!`);
                EndGame();
            }
            setGuess("")
            return
        }
        setGuessText(`${guess} is not a valid word.`);
        setGuess("")
        return



    }




    

    function checkWord(word) {

        return ValidWords.includes(word.toLowerCase())
    }

    function EndGame() {

        setGuessText("")
        setStarted(false)
        setEnded(true)



    }

    function SetLetterCounts(e){
        const value = Number(e.target.value);
        console.log(value)
        console.log(e)
        setLetterCount(value);
    }
    function forceSetLetters(e){
    
    }

    return (
        <>
        <div className={styles.gameLayout}>
            <div className={styles.timer}>
                    {started && <CountDownTimer
                        key={gameId}
                        Time={120}
                        OnComplete={EndGame}
                /> }
            </div>

            <div className={styles.points}>
                {!ended && started && <h2>Points: {points}</h2>}
            </div>
            
            <div className={styles.letterRow}>
                    {started && !ended && <ShuffleLetters callback={shuffleLetters} /> }
                <PrintLetters length={LetterCount} availLetters={AvailableLetters} letters={letters} />
            </div>
            
                { (!started) && 
                    <div className={styles.letterCountRow}>
                        <SetLetterCount value="3" cb={SetLetterCounts} />
                        <SetLetterCount value="4" cb={SetLetterCounts} />
                        <SetLetterCount value="5" cb={SetLetterCounts} />
                        <SetLetterCount value="6" cb={SetLetterCounts} />
                        <SetLetterCount value="7" cb={SetLetterCounts} />
                        <SetLetterCount value="8" cb={SetLetterCounts} />
                        <SetLetterCount value="9" cb={SetLetterCounts} />
                    </div>}
                <br />

                <div className={styles.buttons} style={{ "display": "flex", "gap": "1em", "paddingTop": "1em" }}>
                    <Start handleClick={StartGame} started={started} />
                    {(started && !ended) && <End handleClick={EndGame} />}
                    {(!started) && <ScrambleSubmissionForm
                        setScrambleSubmit={setScrambleSubmit}
                        setForcedScramble={setForcedScramble}
                        forcedScramble={forcedScramble}
                    />}
                </div>

            

            <br />
            <div className={styles.guess}>

                {!ended && started && <SubmissionForm guess={guess} submitted={submitted} handleSubmit={handleSubmit} handleChange={handleChange} />}
            </div>
            <div className={styles.guessText}>
                {!ended && started && <SetGuessText text={guessText} />}
            </div>
            <div className={styles.wordCountSidebar}>

                {!ended && started && <PrintWordCounts wordCounts={wordCounts} guessedWords={guessedWords} />  }
            </div>
            <div className={styles.GameEnd}>
                {ended && <PrintResults length={LetterCount} points={points} letters={letters} validWords={ValidWords} guessedWords={guessedWords} />}
            </div>
            



            </div>
        </>
    )
}




function SetLetterCount({value, cb}){

    return (
        <button className={styles.LetterCountButton}
            onClick={cb}
            value={value}
            >
        {value}
        </button>
        )
    
}


function SetGuessText({ text }) {

    if (!text) {
        return
    }
    return (
        <p>
            {text}
        </p>
    )
}

function Letter({ value, handleClick, className }) {

    return (
        <button
            className={`${styles.letter} ${styles[className]}`}
            onClick={handleClick}>
            {value}
        </button>
    )
}

function Start({ handleClick, started }) {

    return (
        <button
            className={styles.start}
            onClick={handleClick}
        >
            {started ? "Restart" : "Start"}
        </button>
    )
}

function SubmissionForm({ guess, submitted, handleSubmit, handleChange }) {


    return (
        <>

            <form onSubmit={handleSubmit}>
                <label>
                    Enter Words Here!<br />
                    <input type="text" value={guess} onChange={handleChange} />
                </label>
            </form>

        </>
    )
}

function ScrambleSubmissionForm({setScrambleSubmit, forcedScramble, setForcedScramble}){

    return (
        <>
        <form onSubmit={setScrambleSubmit}>
            <label>
                Set Scramble Here!
                <br />
                <input
                    type="text"
                    value={forcedScramble}
                    onChange={(e) => setForcedScramble(e.target.value)}
                />
            </label>
        </form>
        </>
        
    )

}
function generateWord(length) {

    let max = ScrambleList[`${length}`].length;

    const randomNumber = Math.floor(Math.random() * max);

    return ScrambleList[`${length}`][randomNumber];

}

function scrambleWord(word) {

    const letters = word.split("");

    for (let i = letters.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));

        [letters[i], letters[j]] = [letters[j], letters[i]];
    }

    return letters;

}

function End({ handleClick }) {


    return (
        <button
            className={styles.end}
            onClick={handleClick}
        >
            End Round
        </button>
    )

}
function PrintLetters({ length, availLetters, letters }){
    const divs = []

    

    for(let i = 0; i < length; i++){

        divs.push({
            index: i,
            value: letters[i],
            inUse: availLetters[i]
        });
        
    }

    return (
        <>
            {divs.map((letter) => (
            <Letter className={letter.inUse ? "unused" : "used"} key={letter.index} value={letter.value} handleClick={() => { console.log(letter.value) }} />
            ))}
        
        </>
    )
}



function PrintResults({ length, points, letters, validWords, guessedWords }) {
    const Words = []
    const scrambledArray = genScrambledArray(letters.join(""))


    const pointTotals = {
        3: 100,
        4: 400,
        5: 1200,
        6: 2200,
        7: 3000,
        8: 5000,
        9: 10000
    }


    for (const word of validWords) {
        if (canMakeWord(word)) {
            let points = pointTotals[word.length]
            let guessed = false;

            if (guessedWords.includes(word.toUpperCase())) {
                guessed = true
            }

            Words.push(
                {
                    length: word.length,
                    word: word,
                    points: points,
                    guessed: guessed
                }
            )
        }
        
    }


    Words.sort((a, b) => b.length - a.length);



    return (
        <>
            <div className={styles.EndResult}>

                <h1>Total Points: {points}</h1>
                <div className={styles.WordList}>
                    <h3>Word List</h3><hr />
                    <b> Successfully Guessed {guessedWords.length} / {Words.length} words!</b>
                    <br /> <br />
                    {(() => {
                    let lastPoints = null;
                
                    return Words.map((word) => {
                        const showPoints = word.points !== lastPoints;
                        lastPoints = word.points;
                
                        return (
                            <div key={word.word}>
                                {showPoints && (
                                    <div className={styles.PointHeader}>
                                        <br/><b>{word.points}</b>
                                    </div>
                                )}
                
                                <div className={styles.Word}>
                                    {word.guessed ? (
                                        <b>{word.word.toUpperCase()}</b>
                                    ) : (
                                        word.word.toUpperCase()
                                    )}
                                </div>
                            </div>
                        );
                    });
                })()}

                </div>

            </div>

        </>
    )

    function genScrambledArray(word) {
        let arr = Array(26).fill(0)

        for (const letter of word) {
            const l_index = letter.toLowerCase().charCodeAt(0) - 97
            arr[l_index] += 1;
        }
        return arr
    }


    function canMakeWord(word) {


        let wordArr = genScrambledArray(word);

        for (let i = 0; i < 26; i++) {
            if (wordArr[i] <= scrambledArray[i]) {
                continue
            }
            else {
                return false;
            }
        }

        return true


    }


}

function PrintWordCounts({ wordCounts, guessedWords }) {
    return (
        <div className={styles.WordCountPanel}>
            <h3>Words Found</h3>

            {wordCounts.map((count, index) => {
                if (index < 3 || count === 0) return null;

                const guessed =
                    guessedWords.filter(
                        str => str.length === index
                    ).length;

                return (
                    <div
                        className={styles.WordCountRow}
                        key={index}
                    >
                        <span>{index}-Letter</span>
                        <span>{guessed}/{count}</span>
                    </div>
                );
            })}
        </div>
    );
}


function ShuffleLetters({callback}){

    return (
        <>
        <button className={styles.shuffleBtn} onClick={callback}>
        <img className={styles.shuffleImg} src="/api/images/shuffle.png" alt="shuffle"/>
        </button>
        
        </>

        )
    
}
